/** The word next to the pulsing dot: Live, Offline, Connecting or Reconnecting. */
export const statusWord = ({ isOnline, connectionState, hasConnected }) => {
  if (!isOnline) return "Offline";
  if (connectionState === "connected") return "Live";
  return hasConnected ? "Reconnecting" : "Connecting";
};

export const isLive = ({ isOnline, connectionState }) => isOnline && connectionState === "connected";
